export const loadingIcon = 'rotate_right';
